import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./workingPartAdminForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
// import InputSelect from "../../../utils/InputSelect";
import {
  InputDate,
  InputText,
  InputSelect,
  InputTextarea,
  InputAutoComplete,
  BreadCrumb,
} from "@de-prado-dev/react-component-library";

const WorkingPartAdminForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    codes,
    tasks,
    rows,
    onChangeCode,
    isManager,
    onFilterUser,
  } = props;

  const renderListUser = (item) => {
    return item.completeName;
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit
              ? t("forms.workingPart.titleEdit")
              : t("forms.workingPart.titleNew")}
          </h3>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="userUuid"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.user")}
                  name="userUuid"
                  mandatory
                  component={InputAutoComplete}
                  fieldType="text"
                  onSearch={onFilterUser}
                  optionValue="uuid"
                  optionLabel="completeName"
                  textButtonReset={t("clear")}
                  renderItems={renderListUser}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="dailyDate"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.date")}
                  name="dailyDate"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd-MM-yyyy"
                  mandatory
                  defaultHours={15}
                  defaultMinutes={30}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 col-md-3">
                <Field
                  id="codeUuid"
                  name="codeUuid"
                  labelField={t("forms.workingPart.labels.code")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="uuid"
                  options={codes.map((item) => ({
                    ...item,
                    label: !isManager
                      ? item.code
                      : `${item.code} (${item.vivero.name})`,
                  }))}
                  onChangeValue={(value) => {
                    onChangeCode(value);
                    props.setFieldValue("rows", "", true);
                  }}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
              <div className="col-12 col-md-3 mt-2 mt-md-0">
                <Field
                  id="initTime"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.initTime")}
                  name="initTime"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  showTimeSelect
                  dateFormat="HH:mm"
                  mandatory
                  showTimeSelectOnly
                  timeIntervals={30}
                />
              </div>
              <div className="col-12 col-md-3 mt-2 mt-md-0">
                <Field
                  id="endTime"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.endTime")}
                  name="endTime"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  showTimeSelect
                  dateFormat="HH:mm"
                  mandatory
                  showTimeSelectOnly
                  timeIntervals={30}
                />
              </div>
              <div className="col-12 col-md-3 mt-2 mt-md-0">
                <Field
                  id="numPlants"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.numPlants")}
                  name="numPlants"
                  placeholder=""
                  component={InputText}
                  fieldType="number"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 col-md-6">
                <Field
                  id="taskUuid"
                  name="taskUuid"
                  labelField={t("forms.workingPart.labels.task")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="uuid"
                  options={tasks.map((item) => ({
                    ...item,
                    label: item.name,
                  }))}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
              <div className="col-12 col-md-6 mt-2 mt-md-0">
                <Field
                  id="rows"
                  name="rows"
                  labelField={t("forms.workingPart.labels.rows")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="value"
                  options={rows}
                  classNamePrefix="dark"
                  mandatory
                  isMultiple
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="comments"
                  className="form-control"
                  labelField={t("forms.workingPart.labels.comments")}
                  name="comments"
                  placeholder=""
                  component={InputTextarea}
                  rows={5}
                />
              </div>
            </div>
            {/* <div className="row"><div className="col-12"><Field id="date" className="form-control" labelField={t('forms.workingPart.labels.date')} name="date" placeholder="" component={InputDate} language="es" showTimeSelect dateFormat="dd/MM/yyyy HH:mm" mandatory /></div></div>
                <div className="row"><div className="col-12"><Field id="userUuid" className="form-control" labelField={t('forms.workingPart.labels.userUuid')} name="userUuid" placeholder="" component={InputSelect} optionLabel="" optionValue="" options={[]}"mandatory /></div></div>
                <div className="row"><div className="col-12"><Field id="comments" className="form-control" labelField={t('forms.workingPart.labels.comments')} name="comments" placeholder="" component={InputText} fieldType="text" /></div></div>
                <div className="row"><div className="col-12"><Field id="taskTime" className="form-control" labelField={t('forms.workingPart.labels.taskTime')} name="taskTime" placeholder="" component={InputText} fieldType="number" /></div></div>
                 <div className="row"><div className="col-12"><Field id="status" className="form-control" labelField={t('forms.workingPart.labels.status')} name="status" placeholder="" component={InputText} fieldType="text" mandatory /></div></div>
                <div className="row"><div className="col-12"><Field id="isNight" className="form-control" labelField={t('forms.workingPart.labels.isNight')} name="isNight" placeholder="" component={InputCheck} mandatory /></div></div>
                <div className="row"><div className="col-12"><Field id="viveroUuid" className="form-control" labelField={t('forms.workingPart.labels.viveroUuid')} name="viveroUuid" placeholder="" component={InputSelect} optionLabel="" optionValue="" options={[]}"mandatory /></div></div> */}
            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.workingPart.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.workingPart.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

WorkingPartAdminForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onBack: PropTypes.func,
  edit: PropTypes.bool,
};

const WorkingPartAdminFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "WorkingPartAdminForm",
})(WorkingPartAdminForm);

export default WorkingPartAdminFormF;
